//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { RepertoireAssignmentUpdateItem } from './RepertoireAssignmentUpdateItem';

export class BatchRepertoireAssignmentUpdateItem extends RepertoireAssignmentUpdateItem {
    StudentID: string | null = null;
    RepertoireID: string | null = null;

    constructor(initializer?: Partial<BatchRepertoireAssignmentUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "BatchRepertoireAssignmentUpdateItem";
}
